import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Notification from '../../components/Notification';
import SelectDropdown from '../../components/SelectDropdown';
import {
  Container,
  Form,
  Preview,
  ButtonGroup,
  SendButton,
  RecordButton,
  FormGrid,
  FormGroup,
} from './styles';
import { navigateToUrl } from '../../utils/navigation';

const api = axios.create({
  baseURL: 'http://localhost:51111',
});

const FONT_OPTIONS = [
  'Arial',
  'Helvetica',
  'Courier New',
  'Georgia',
  'Times New Roman',
  'Verdana',
  'Mulish',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
].map(name => ({ value: name, label: name }));

const Engraving = () => {
  const [text, setText] = useState('');
  const [font, setFont] = useState('Arial');
  const [isRecordEnabled, setIsRecordEnabled] = useState(false);
  const pollingInterval = useRef(null);

  const startPolling = () => {
    if (pollingInterval.current) return;

    pollingInterval.current = setInterval(async () => {
      try {
        const response = await api.get('/text_ready');

        if (!response.data?.ready) return;

        setIsRecordEnabled(true);
        clearInterval(pollingInterval.current);
        pollingInterval.current = null;
        Notification({
          type: Notification.types.SUCCESS,
          message: 'Máquina pronta para gravação!',
        });
      } catch (err) {
        console.error('Erro ao verificar status:', err);
      }
    }, 1000);
  };

  const stopPolling = () => {
    if (pollingInterval.current) {
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
    }
  };

  useEffect(() => {
    return () => stopPolling();
  }, []);

  const handleSendName = async () => {
    if (!text) {
      Notification({
        type: Notification.types.ERROR,
        message: 'Por favor, digite um nome antes de enviar.',
      });
      return;
    }

    try {
      const response = await api.post('/send_text', {
        text,
        font,
      });
      Notification({
        type: Notification.types.SUCCESS,
        message: response.data || 'Nome enviado com sucesso!',
      });
      startPolling();
    } catch (err) {
      Notification({
        type: Notification.types.ERROR,
        message: 'Erro ao enviar nome para o servidor.',
      });
      console.error(err);
    }
  };

  const handleRecord = async e => {
    e.preventDefault();

    if (!text) {
      Notification({
        type: Notification.types.ERROR,
        message: 'Por favor, digite um nome antes de gravar.',
      });
      return;
    }

    try {
      const response = await api.post('/mark', {
        text,
        font,
      });
      Notification({
        type: Notification.types.SUCCESS,
        message: `🔴 Gravação iniciada: ${response.data}`,
      });
      setIsRecordEnabled(false);
      stopPolling();
      navigateToUrl(
        'https://docs.google.com/forms/d/e/1FAIpQLSdjqwuybj_c_bgRxopZx1KiTiB_NGc9E6cqIY6LlrP4b6vLNw/viewform'
      );
    } catch (err) {
      Notification({
        type: Notification.types.ERROR,
        message: 'Erro ao iniciar gravação.',
      });
      console.error(err);
    }
  };

  return (
    <Container>
      <div>
        <h2>Gravação Nome</h2>
        <Form onSubmit={handleRecord}>
          <FormGrid>
            <FormGroup className="full-width">
              <label htmlFor="nome">Nome:</label>
              <input
                type="text"
                id="nome"
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="Digite seu nome"
                required
              />
            </FormGroup>

            <FormGroup className="full-width">
              <span>Fonte:</span>
              <SelectDropdown
                variant="box"
                options={FONT_OPTIONS}
                value={font}
                onChange={setFont}
                ariaLabel="Fonte"
                /* Cada opção é desenhada na própria fonte — a lista vira a
                   prévia, que o <select> nativo não conseguia dar. */
                formatOptionLabel={option => (
                  <span style={{ fontFamily: option.value }}>
                    {option.label}
                  </span>
                )}
              />
            </FormGroup>
          </FormGrid>

          <Preview fontFamily={font}>{text || 'Pré-visualização'}</Preview>

          <ButtonGroup>
            <SendButton type="button" onClick={handleSendName}>
              📤 ENVIAR NOME
            </SendButton>
            <RecordButton type="submit" disabled={!isRecordEnabled}>
              🔴 GRAVAR
            </RecordButton>
          </ButtonGroup>
        </Form>
      </div>
    </Container>
  );
};

export default Engraving;
